export default {
  cardElement: {
    padding: "16px",
    border: "1px solid #EDEFF2",
    "margin-bottom": "16px",
    "border-radius": "4px",
  },
  cardErrors: {
    position: "relative",
    top: "-8px",
    color: "#ff0000",
    "font-family": "Lato, sans-serif",
    "font-size": "14px",
    "line-height": "20px",
    "font-weight": "400",
  },

  paymentRequestButton: {
    "margin-bottom": "24px",
  },

  stripeComponentFormRow: {
    "margin-bottom": "24px",
  },

  stripeComponentCardIcons: {
    opacity: "0.6",
    "text-align": "right",
  },

  stripeComponentPaymentRequest: {
    display: "flex",
    "align-items": "center",
    "text-align": "center",
    gap: "24px",
    "margin-bottom": "16px",
  },

  stripeComponentPaymentRequestParagraph: {
    "margin-bottom": 0,
  },

  line: {
    "flex-grow": 1,
    "border-bottom": "1px solid #EDEFF2",
  },
};
